/* eslint-disable react-hooks/exhaustive-deps */
import Button from "@mostrans/web-components/components/base/Button";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Container,
  Divider,
  Paper,
  Typography,
} from "@mui/material";
import React, { createRef, useEffect, useRef, useState } from "react";
import { useApolloClient } from "@apollo/client";
import {
  getCandidateByID,
  getLogActivityPapikostik,
  getPapikostik,
} from "../../../graphql/query";
import Input from "@mostrans/web-components/components/base/Input";
import {
  insertLogPapikostik,
  scoringPapikostik,
} from "../../../graphql/mutations";
import Loading from "../../../components/Loading";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  getDetailJobByCandidateID,
  globalLoadingAtom,
} from "../../../shared/globalStates";
import { toastError, toastSuccess } from "../../../shared/helpers";
import Success from "../../../components/Success";
import { isEmpty } from "lodash";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { handleTimePsikotest } from "./Assesment/handleTimePsikotest";
import { getDetailCandidate } from "../../../shared/atom/detailCandidate";

export const Papikostik = () => {
  const client = useApolloClient();
  const [loading, setLoading] = useRecoilState(globalLoadingAtom);
  const [index, setIndex] = useState(0);
  const [number, setNumber] = useState(1);
  const [prev, setPrev] = useState(0);
  const [next, setNext] = useState(10);
  const [data, setData] = useState([]);
  const [info, setInfo] = useState(true);
  const [values, setValues] = useState([]);
  const [log, setLog] = useState([]);
  const [insertLog, setInsertLog] = useState([]);
  const [selected, setSelected] = useState([]);
  const [errIndex, setErrIndex] = useState(null);
  const [success, setSuccess] = useState(false);
  const setDetailCandidate = useSetRecoilState(getDetailCandidate);
  const refs = useRef([]);
  refs.current = [...Array(10).keys()].map(
    (_, i) => refs.current[i] ?? createRef()
  );

  useEffect(() => {
    getPapikostik(client).then(setData);
    getLogActivityPapikostik(client).then(setLog);
  }, []);

  useEffect(() => {
    setValues(
      log.map((item) => {
        return {
          question_number: item.question_number,
          choice: item.answer,
        };
      })
    );
    setInsertLog(
      log.map((item) => {
        return {
          question_number: item.question_number,
          answer: item.answer,
        };
      })
    );
    setSelected(
      log.map((item) => {
        return item.answer;
      })
    );
    if (log.length) {
      setPrev(log.length);
      setNext(log.length + 10);
    }
  }, [log]);

  useEffect(() => {
    setValues((oldValues) => {
      oldValues[number - 1] = {
        question_number: number,
        choice: selected[number - 1],
      };
      return [...oldValues];
    });
    setInsertLog((oldValues) => {
      oldValues[number - 1] = {
        question_number: number,
        answer: selected[number - 1],
      };
      return [...oldValues];
    });
    setErrIndex(null);
  }, [selected, index]);

  useEffect(() => {
    setErrIndex(errIndex);
    refs.current[errIndex]?.current.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center",
    });
  }, [errIndex]);

  const handleNext = async () => {
    var isNull = false;
    var index = 0;
    if (values.length >= next) {
      for (const i in values) {
        if (values.length > next) break;
        if (selected[i] === null || selected[i] === undefined) {
          if (values.length > next) return setErrIndex(parseInt(i - 10));
          if (values.length <= next) return setErrIndex(parseInt(i - prev));
          setErrIndex(parseInt(i));
          isNull = true;
          break;
        }
      }
      if (!isNull && next !== data.length) {
        const result = await insertLogPapikostik(client, insertLog);
        if (result.status !== "000") {
        } else {
          setNext(next + 10);
          setPrev(prev + 10);
          setErrIndex(0);
        }
        isNull = false;
      } else {
        //@Scoring @Insert @Kirim
        setLoading(true);
        const result = await scoringPapikostik(client, values);
        if (result.status !== "000") {
          setLoading(false);
          toastError("Error, try again later!");
        } else {
          setLoading(false);
          getCandidateByID(client).then(setDetailCandidate);
          toastSuccess("Success, Thank you for completing MOSTEST 2");
          setSuccess(true);
        }
      }
    } else {
      index = selected.length;
      if (values.length > next) return setErrIndex(index - next);
      if (values.length <= next) return setErrIndex(index - prev);
      setErrIndex(index);
    }
  };

  const handlePrev = () => {
    setNext(next - 10);
    setPrev(prev - 10);
  };

  var title = "MOSTEST 2";
  var text =
    "You have completed the MOSTEST 2, we will contact you as soon as possible. ";
  var subtext = "Thank you for your participation. Page will be moved in";

  return info ? (
    <Information setInfo={setInfo} />
  ) : success ? (
    <Success
      title={title}
      text={text}
      subtext={subtext}
      timer={15000}
      button
      route="ASSESMENT"
    />
  ) : (
    <React.Fragment>
      {loading && <Loading />}
      <Container maxWidth="md">
        <Box>
          <Box display="flex" justifyContent="space-between">
            <Typography
              component="span"
              fontSize={36}
              textTransform="uppercase"
              sx={{ fontWeight: "400 !important" }}>
              MOSTEST 2
            </Typography>
            <Typography
              component="span"
              fontSize={36}
              textTransform="uppercase"
              sx={{ fontWeight: "400 !important" }}>
              {`SOAL ${selected.length}/${data.length}`}
            </Typography>
          </Box>
          <Divider sx={{ marginY: "20px" }} />
          <Typography>
            Pilih salah satu opsi yang paling menggambarkan diri Kamu di setiap
            barisnya. Pastikan Kamu berada di situasi yang tenang agar hasilnya
            dapat optimal.
          </Typography>
        </Box>
        <Box>
          <div
            className="progress"
            style={{ height: "20px", margin: "20px 0" }}>
            <div
              className="progress-bar progress-bar-striped bg-primary-main"
              role="progressbar"
              style={{ width: selected.length + "%" }}
              aria-valuenow={selected.length}
              aria-valuemin="0"
              aria-valuemax={data.length}></div>
          </div>
          {data.slice(prev, next).map((result, index) => (
            <Paper
              key={result.id}
              ref={refs.current[index]}
              className="shadow-soft-s3"
              variant="outlined"
              sx={{
                marginY: "25px",
                display: "grid",
                padding: "20px",
                fontSize: "14px",
                fontWeight: "500",
                boxShadow:
                  errIndex === index &&
                  "0px 3px 5px #d32f2f, 0px 0px 1px #d32f2f",
              }}>
              <label>
                <Input
                  type="radio"
                  checked={selected[result.id - 1] === result.option_a.score}
                  onChange={() => {
                    setSelected((old) => {
                      old[result.id - 1] = result.option_a.score;
                      return [...old];
                    });
                    setIndex(index);
                    setNumber(result.number);
                  }}
                  style={{ paddingRight: "10px" }}
                />
                &nbsp;
                {result.option_a.option}
              </label>
              <label>
                <Input
                  type="radio"
                  checked={selected[result.id - 1] === result.option_b.score}
                  onChange={() => {
                    setSelected((old) => {
                      old[result.id - 1] = result.option_b.score;
                      return [...old];
                    });
                    setIndex(index);
                    setNumber(result.number);
                  }}
                  style={{ paddingRight: "10px" }}
                />
                &nbsp;
                {result.option_b.option}
              </label>
            </Paper>
          ))}
        </Box>
        {/* <Paper justifyContent="center">
          <Box textAlign="center" display="grid" margin="20px">
            <div className="listbox" style={{ margin: "20px" }}>
              {data.slice(0, data.length / 10).map((item, i) => (
                <span
                  className={`text-primary-main-hover font-size-main bg-neutral-n2-hover`}
                  style={{
                    display: "inline-block",
                    left: "50%",
                    width: "8%",
                    margin: "5px",
                    border: "2px solid #e1e1e1",
                    cursor: "pointer",
                    background:
                      (values[i].choice && "#F0F0F0") ||
                      (values[next]?.choice !== null &&
                        values[next] !== undefined &&
                        values[next] !== null &&
                        "#D9D9D9"),
                  }}>
                  {pagination(i)}
                </span>
              ))}
            </div>
          </Box>
        </Paper> */}
        <Box textAlign="center">
          <Button
            onClick={() => handlePrev()}
            sx={{ margin: "10px 0", marginRight: "20px" }}
            variant="contained"
            color="primary"
            disabled={prev === 0}
            startIcon={<span className="material-icons"> arrow_back </span>}>
            Kembali
          </Button>
          <Button
            onClick={() => handleNext()}
            sx={{ margin: "10px 0" }}
            variant="contained"
            color="primary"
            endIcon={<span className="material-icons"> arrow_forward </span>}>
            {next === data.length ? "Selesai" : "Selanjutnya"}
          </Button>
        </Box>
      </Container>
    </React.Fragment>
  );
};

export default Papikostik;

export const Information = ({ setInfo }) => {
  const client = useApolloClient();
  const [alreadyTest, setAlreadyTest] = useState(false);
  const [data, setData] = useState([]);
  const history = useHistory();
  const [loading, setLoading] = useRecoilState(globalLoadingAtom);
  const [candidate, setCandidate] = useRecoilState(getDetailCandidate);

  useEffect(() => {
    setLoading(true);
    if (isEmpty(candidate)) {
      getCandidateByID(client).then((response) => {
        const isAssessment = handleTimePsikotest(response.psikotest_date);
        if (!isAssessment) {
          history.push("/career/assessment");
        }
        setData(response);
        setCandidate(response);
        setAlreadyTest(response.is_papikostik_done);
      });
    } else {
      const isAssessment = handleTimePsikotest(candidate.psikotest_date);
      if (!isAssessment) {
        history.push("/career/assessment");
      }
      setData(candidate);
      setAlreadyTest(candidate.is_papikostik_done);
    }
    setLoading(false);
  }, []);

  const handleBack = () => {
    history.goBack();
  };

  return (
    <React.Fragment>
      {loading ? (
        <Loading />
      ) : (
        <Card
          className="shadow-soft-s3"
          variant="outlined"
          sx={{
            width: "100vh",
            margin: "auto",
            display: loading ? "none" : "block",
          }}>
          <CardHeader
            sx={{ textAlign: "center", justifyContent: "center" }}
            title={
              <Box component="div">
                <span
                  className={`material-icons ${
                    alreadyTest ? "text-danger-main" : "text-primary-main"
                  }`}
                  style={{
                    fontSize: "50px",
                    padding: "10px 0",
                  }}>
                  info
                </span>
                <p
                  className={`font-weight-w600 font-size-h4 ${
                    alreadyTest ? "text-danger-main" : "text-primary-main"
                  }`}>
                  {alreadyTest
                    ? "Telah selesai mengerjakan MOSTEST 2"
                    : "Sebelum memulai, perhatikan petunjuk dibawah ini:"}
                </p>
              </Box>
            }
          />
          <CardContent>
            <Typography
              textAlign="center"
              display={alreadyTest ? "block" : "none"}>
              Maaf kamu tidak diperkenankan untuk mengerjakan test lebih dari 1
              kali
            </Typography>
            <Typography
              textAlign="center"
              display={alreadyTest ? "block" : "none"}>
              Kamu telah menyelesaikan MOSTEST ini pada&nbsp;
              {!isEmpty(data.Papikostik) && data?.Papikostik[0]?.created_date}
            </Typography>
            <Typography
              textAlign="center"
              display={alreadyTest ? "block" : "none"}>
              Terjadi kesalahan? Hubungi HRD jika terjadi kesalahan.
            </Typography>
            <Box display={alreadyTest ? "none" : "block"}>
              <Typography>
                Anda akan dihadapkan kepada 90 Soal. Dalam setiap soal, akan
                terdapat 2 buah pernyataan. Tugas Anda adalah memilih satu
                pernyataan yang paling MENGGAMBARKAN atau paling mendekati diri
                Anda. Pada evaluasi ini, tidak terdapat jawaban benar maupun
                salah, maka dari itu silahkan isi dengan jujur dan spontan.
              </Typography>
              <Typography component="div">
                <ul>
                  Contoh:
                  <li>A. Saya seorang pekerja "keras"</li>
                  <li>B. Saya bukan seorang pemurung</li>
                </ul>
              </Typography>
              <Typography>
                Jika anda merasa pernyataan B paling menggambarkan diri Anda,
                silahkan pilih pernyataan tersebut. Bekerjalah dengan cepat,
                tetapi jangan sampai ada nomor pernyataan yang terlewatkan.
              </Typography>
            </Box>
            <Box textAlign="center" py={2}>
              <Button
                onClick={() => handleBack()}
                sx={{ margin: "10px 0" }}
                variant="contained"
                color="danger"
                style={{ marginRight: "25px" }}>
                Kembali
              </Button>
              <Button
                onClick={() => setInfo(false)}
                sx={{ margin: "10px 0" }}
                variant="contained"
                color="primary"
                style={{
                  display: alreadyTest ? "none" : "unset",
                }}>
                Saya mengerti
              </Button>
            </Box>
          </CardContent>
        </Card>
      )}
    </React.Fragment>
  );
};
